import api, {
     deleteFn,
    getFn,
    IdApiArg, insertFn,
    PaginatedResult,
    prepareFTX,
    SortColumn,
    UpdateArg, updateFn,
    UpdateResp
} from "../../api";
import {Tables, TablesInsert, TablesUpdate} from "../../apitypes";
import {supabase} from "../../supabase";

export interface ProductFilter {
    active?: boolean,
    filter?: string,
    page: number,
    pageSize: number,
    sort?: SortColumn[],
}


export const peopleApi = api.injectEndpoints({
    endpoints: (build) => ({
        // Machine types
        getProduct: build.query<PaginatedResult<Tables<"product">>, ProductFilter>({
            queryFn: async (args) => {
                let q = supabase
                    .from("product")
                    .select("*", {count: "estimated"})

                if (args.filter) {
                    q = q.textSearch("product_ftx", prepareFTX(args.filter))
                }
                if (args.active === true || args.active === false) {
                    q = q.eq("Active", args.active)
                }
                if (args.sort) {
                    args.sort.forEach(s => {
                        q = q.order(s.col, {ascending: s.dir == "asc"})
                    })
                }
                const {data, count, error} = await q.range(args.pageSize * args.page, args.pageSize * (args.page + 1));

                if (error) return {error};
                return {data: {result: data, count}}
            },
            providesTags: ["Product"]
        }),
        getProductByDn: build.query<PaginatedResult<Tables<"product">>, ProductFilter & {workOrderID: number | undefined}>({
            queryFn: async (args) => {
                if (args.workOrderID === undefined) return {data: {result: [], count: 0}}
                const {data: wo, error: woError} = await supabase
                    .from("workOrderOrderedProduct")
                    .select("productCode")
                    .eq("workOrderID", args.workOrderID)

                if (woError) return {error: woError}
                if (wo == null || wo.length === 0) return {data: {result: [], count: 0}}

                let q = supabase
                    .from("product")
                    .select("*", {count: "estimated"})
                    .in("Code", wo.map((p) => p.productCode || ""))

                if (args.filter) {
                    q = q.textSearch("product_ftx", prepareFTX(args.filter))
                }
                if (args.active === true || args.active === false) {
                    q = q.eq("Active", args.active)
                }
                if (args.sort) {
                    args.sort.forEach(s => {
                        q = q.order(s.col, {ascending: s.dir == "asc"})
                    })
                }
                const {data, count, error} = await q.range(args.pageSize * args.page, args.pageSize * (args.page + 1));

                if (error) return {error};
                return {data: {result: data, count}}
            },
            providesTags: ["Product"]
        }),
        getProductById: build.query<Tables<"product"> | null, IdApiArg>({
                query: getFn("product"),
            providesTags: ["Product"]
        }),
        postProduct: build.mutation<UpdateResp, TablesInsert<"product">>({
           query: insertFn("product"),
            invalidatesTags: ["Product"],
        }),
        deleteProductById: build.mutation<UpdateResp, IdApiArg>({
            query: deleteFn("product"),
            invalidatesTags: ["Product"],
        }),
        putProductById: build.mutation<UpdateResp, UpdateArg<"product">>({
            query: updateFn("product"),
            invalidatesTags: ["Product"],
        }),
    })
});


export type ProductApiPut = TablesUpdate<"product">

export type ProductApiGet = Tables<"product">


export const {

    useGetProductQuery,
    useGetProductByIdQuery,
    usePostProductMutation,
    usePutProductByIdMutation,
    useDeleteProductByIdMutation,
    useGetProductByDnQuery,

} = peopleApi;
